<script lang="ts" setup>
import { computed } from '#imports';

interface Props {

    /**
     * Full screen loader
     */
    full?: boolean;

    /**
     * Apply accent color
     */
    colorful?: boolean;

    /**
     * Each dot size
     */
    dotSize?: number;
}

const props = withDefaults(
    defineProps<Props>(),
    { dotSize: 10 }
);

const dotStyle = computed(() => ({
    width: `${props.dotSize}px`,
    height: `${props.dotSize}px`
}));

</script>

<template>
  <div class="loader"
       v-bind="$attrs"
       :class="{ 'container--colorful': colorful }"
  >
    <div class="dot"
         :style="dotStyle"
    ></div>
    <div class="dot"
         :style="dotStyle"
    ></div>
    <div class="dot"
         :style="dotStyle"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
}

.full-wrapper {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}

.dot {
  content: '';
  display: inline-block;
  margin: 3px;
  animation: scale 1.2s infinite ease-in-out both;
  border-radius: 50%;
  background-color: #fff;
}

.container--colorful .dot {
  background-color: var(--content-primary);
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes scale {
  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
